import React from 'react';
import { useParams } from 'react-router-dom';

const TestPublicPage = () => {
  const { articleId } = useParams();
  
  return (
    <div style={{ padding: '20px', backgroundColor: '#f0f0f0' }}>
      <h1>Teste de Rota Pública</h1>
      <p>ID do artigo: {articleId}</p>
      <p>Se você está vendo isso, a rota está funcionando!</p>
    </div>
  );
};

export default TestPublicPage;


